import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import {
  BackofficeGetCompaniesResponseDataSchema,
  DataResponseWithPagination,
  GetBackofficeCompaniesSchema,
} from "schema"
import { z } from "zod"

type Query = z.input<typeof GetBackofficeCompaniesSchema>
type Response = DataResponseWithPagination<z.infer<typeof BackofficeGetCompaniesResponseDataSchema>>
type OnSuccessFn = (data: Response) => void

export const getBackofficeCompaniesQueryKey = (query: Query = {}) => ["backofficeCompanies", query]

type Props = {
  query?: Query
  onSuccess?: OnSuccessFn
}

export const getBackofficeCompaniesQuery = ({ query, onSuccess }: Props) => {
  return queryOptions({
    queryKey: getBackofficeCompaniesQueryKey(query),
    queryFn: async () => {
      const { data } = await axios.get<Response>("/backoffice/companies", { params: query })
      onSuccess?.(data)
      return data.data
    },
  })
}
